module.exports = __webpack_public_path__ + "img/toolkit-dwg-sample.ecdae700.png";